import IrqMainTitle from '../atoms/typography/IrqMainTitle';

export const IrqTitle = ({content, icon}) => {
  return (
    <div className="irq-title-wrapper">
      <div className="irq-icon-wrapper">
        <img src={icon} />
      </div>
      <div>
        <IrqMainTitle>{content.title}</IrqMainTitle>
      </div>
    </div>
  )
}
